import { useMediaQuery, useWindowSize } from 'usehooks-ts';
import { useMemo } from 'react';

export const TARGET_SCALE_XL_WIDTH = 1920;
export const TARGET_SCALE_XL_HEIGHT = 1680;

export const TARGET_SCALE_LG_WIDTH = 1376;
export const TARGET_SCALE_LG_HEIGHT = 1080;

export const useZoomScale = () => {
  const { width, height } = useWindowSize();
  const isLgScreen = useMediaQuery('(min-width: 1024px)');
  const isXlScreen = useMediaQuery('(min-width: 1920px)');

  const maxWidth = useMemo(() => {
    if (isXlScreen) {
      return TARGET_SCALE_XL_WIDTH;
    }
    if (isLgScreen) {
      return TARGET_SCALE_LG_WIDTH;
    }
    return TARGET_SCALE_LG_WIDTH; // Default to LG settings for smaller screens
  }, [isXlScreen, isLgScreen]);

  const maxHeight = useMemo(() => {
    if (isXlScreen) {
      return TARGET_SCALE_XL_HEIGHT;
    }
    if (isLgScreen) {
      return TARGET_SCALE_LG_HEIGHT;
    }
    return TARGET_SCALE_LG_HEIGHT; // Default to LG settings for smaller screens
  }, [isXlScreen, isLgScreen]);

  const scale = useMemo(() => {
    if (width <= maxWidth && height <= maxHeight) {
      return 1;
    }

    const widthScale = Math.max(0, maxWidth / width);
    const heightScale = Math.min(Math.max(0, height / maxHeight), 1);

    // Use the smaller scale to ensure content fits in both dimensions
    return Math.min(widthScale, heightScale);
  }, [width, height, maxWidth, maxHeight]);

  return { scale, width, height };
};
